<template>
  <div class="app-footer" :class="{'app-footer--mobile': deviceType === 'mobile'}">
    <div class="app-footer__container">
      <!-- Logo部分 -->
      <div class="app-footer__section app-footer__logo-section">
        <div class="app-footer__logo-container">
          <img :src="domainConfig?.['siteIcon']" alt="Logo" class="app-footer__logo">
          <div class="app-footer__brand">{{domainConfig?.['siteName']}}</div>
        </div>
        <div class="app-footer__desc" v-html="domainConfig?.['ABOUTUS']"></div>

        <!-- 社交图标部分 -->
        <div class="app-footer__social-icons">
          <a @click="showToast" class="app-footer__social-link">
            <img src="@/assets/default/tiktok-icon.svg" alt="TikTok"
              class="app-footer__social-icon">
          </a>
          <a @click="showToast" class="app-footer__social-link">
            <img src="@/assets/default/x-icon.svg" alt="Twitter" class="app-footer__social-icon">
          </a>
          <a @click="showToast" class="app-footer__social-link">
            <img src="@/assets/default/facebook-icon.svg" alt="Facebook"
              class="app-footer__social-icon">
          </a>
          <a @click="showToast" class="app-footer__social-link">
            <img src="@/assets/default/instagram-icon.svg" alt="Instagram"
              class="app-footer__social-icon">
          </a>
        </div>

        <!-- 版权信息 -->
        <div class="app-footer__copyright" v-if="deviceType !== 'mobile'">
          Copyright © 2025 {{domainConfig?.['siteName']}}. All Rights Reserved.
        </div>
      </div>

      <!-- 分割线 -->
      <div class="app-footer__divider"></div>

      <div class="app-footer__right-section">
        <!-- 资源部分 -->
        <div class="app-footer__section app-footer__resources">
          <div class="app-footer__section-title">Resources</div>
          <div class="app-footer__links">
            <div class="app-footer__link-item">
              <router-link :to="getFooterLink('/terms-of-service')" class="app-footer__link">
                Terms of Service
              </router-link>
            </div>
            <div class="app-footer__link-item">
              <router-link :to="getFooterLink('/privacy-policy')" class="app-footer__link">
                Privacy Policy
              </router-link>
            </div>
            <div class="app-footer__link-item">
              <router-link :to="getFooterLink('/disclaimer')" class="app-footer__link">
                Disclaimer
              </router-link>
            </div>
            <div class="app-footer__link-item">
              <router-link :to="getFooterLink('/about-us')" class="app-footer__link">
                About Us
              </router-link>
            </div>
          </div>
        </div>

        <!-- 联系我们部分 -->
        <div class="app-footer__section app-footer__contact">
          <div class="app-footer__section-title">Contact us</div>
          <div class="app-footer__links">
            <div class="app-footer__link-item">
              <a class="app-footer__link"
                :href="`mailto:${domainConfig['IAMEMAIL'] || 'timeincities.support@gmail.com'}`">
                {{ domainConfig?.['IAMEMAIL'] || 'timeincities.support@gmail.com' }}
              </a>
            </div>
          </div>
        </div>

      </div>
      <div class="app-footer__copyright" v-if="deviceType === 'mobile'">
        Copyright © 2025 {{domainConfig?.['siteName']}}. All Rights Reserved.
      </div>
    </div>

    <!-- Toast 提示 -->
    <div class="app-footer__toast" v-if="showToastMessage">
      <div class="app-footer__toast-content">
        Link Copied
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'AppFooter',
  data () {
    return {
      showToastMessage: false,
      toastTimer: null
    }
  },
  computed: {
    ...mapGetters({
      deviceType: 'deviceType',
      domainConfig: 'domainConfig'
    })
  },
  methods: {
    // 获取页脚链接（支持channel参数）
    getFooterLink (link) {
      // // 获取当前URL的查询参数
      const currentQuery = this.$route.query;
      const queryString = Object.keys(currentQuery).length > 0
        ? `?${new URLSearchParams(currentQuery).toString()}`
        : '';

      // 检查是否存在channel参数
      if (this.$route.params.channel) {
        return `/${this.$route.params.channel}${link}${queryString}`;
      }
      return `${link}${queryString}`;
    },
    showToast () {
      // 获取当前页面的URL
      const currentUrl = window.location.href;

      // 使用navigator.clipboard API复制链接到剪贴板
      try {
        // 使用现代剪贴板API
        navigator.clipboard.writeText(currentUrl)
          .then(() => {
            console.log('URL已复制到剪贴板:', currentUrl);

            // 显示Toast提示
            this.showToastMessage = true;

            // 清除之前的定时器
            if (this.toastTimer) {
              clearTimeout(this.toastTimer);
            }

            // 设置新的定时器，2秒后自动关闭
            this.toastTimer = setTimeout(() => {
              this.showToastMessage = false;
            }, 2000);
          })
          .catch(err => {
            console.error('无法复制URL:', err);
            // 剪贴板API失败时，尝试传统方法
            this.fallbackCopyToClipboard(currentUrl);
          });
      } catch (error) {
        console.error('复制过程出错:', error);
        // 如果navigator.clipboard不可用，尝试传统方法
        this.fallbackCopyToClipboard(currentUrl);
      }
    },

    // 后备的复制方法，适用于不支持clipboard API的浏览器
    fallbackCopyToClipboard (text) {
      // 创建一个临时textarea元素
      const textArea = document.createElement('textarea');
      textArea.value = text;

      // 设置样式使其不可见
      textArea.style.position = 'fixed';
      textArea.style.top = '0';
      textArea.style.left = '0';
      textArea.style.width = '2em';
      textArea.style.height = '2em';
      textArea.style.padding = '0';
      textArea.style.border = 'none';
      textArea.style.outline = 'none';
      textArea.style.boxShadow = 'none';
      textArea.style.background = 'transparent';

      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        // 执行复制命令
        const successful = document.execCommand('copy');
        if (successful) {
          console.log('使用传统方法复制URL成功');
          // 显示Toast提示
          this.showToastMessage = true;

          // 清除之前的定时器
          if (this.toastTimer) {
            clearTimeout(this.toastTimer);
          }

          // 设置新的定时器，2秒后自动关闭
          this.toastTimer = setTimeout(() => {
            this.showToastMessage = false;
          }, 2000);
        } else {
          console.error('使用传统方法复制失败');
        }
      } catch (err) {
        console.error('复制出错:', err);
      }

      // 清理临时元素
      document.body.removeChild(textArea);
    }
  },
  beforeDestroy () {
    // 组件销毁前清除定时器
    if (this.toastTimer) {
      clearTimeout(this.toastTimer);
    }
  }
}
</script>

<style lang="scss">
@import '~@/css/variables.scss';

.app-footer {
	// background: linear-gradient(180deg, rgba(242, 244, 246, 1) 0%, rgba(255, 255, 255, 1) 100%);
	background: linear-gradient(180deg, #0d0c0f 0%, #2a282e 100%);
	padding: rem(52) rem(80);
	display: flex;
	flex-direction: column;
	gap: rem(28);
	align-items: flex-start;
	justify-content: flex-start;
	width: 100%;
	box-sizing: border-box;

	&__container {
		display: flex;
		flex-direction: row;
		gap: rem(120);
		align-items: flex-start;
		justify-content: flex-start;
		width: 100%;
	}

	&__logo-section {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: space-between;
		height: rem(200);
		flex-shrink: 0;
	}

	&__logo-container {
		background: #0d0c0f;
		border-radius: rem(8);
		padding: rem(8) rem(16) rem(8) rem(12);
		display: flex;
		flex-direction: row;
		gap: rem(12);
		align-items: center;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;
		cursor: pointer;
	}

	&__logo {
		flex-shrink: 0;
		width: rem(28);
		height: rem(28);
		position: relative;
		overflow: visible;
	}

	&__brand {
		color: #ffffff;
		text-align: left;
		font-size: rem(20);
		line-height: rem(20);
		font-weight: 700;
		text-transform: uppercase;
		position: relative;
	}

	&__desc {
		color: #fff;
		font-size: rem(12);
		font-style: normal;
		font-weight: 400;
		line-height: rem(20); /* 166.667% */
		width: rem(368);
		// margin-bottom: rem(20);
	}

	&__social-icons {
		display: flex;
		flex-direction: row;
		gap: rem(8);
		align-items: flex-start;
		// margin-bottom: rem(16);
	}

	&__social-link {
		border-radius: rem(100);
		background: #fe324b;
		padding: rem(7);
		display: flex;
		align-items: center;
		justify-content: center;
		width: rem(28);
		height: rem(28);
		box-sizing: border-box;
	}

	&__social-icon {
		width: rem(18);
		height: rem(18);
	}

	&__copyright {
		color: rgba(#fff, 0.3);
		font-size: rem(12);
		line-height: rem(12);
		font-weight: 400;
		text-align: center;
	}

	&__divider {
		opacity: 0.1;
		background: #fff;
		width: rem(1);
		height: rem(200);
		flex-shrink: 0;
	}

	&__right-section {
		display: flex;
		flex-direction: row;
		gap: rem(88);
		align-items: flex-start;
	}

	&__section {
		display: flex;
		flex-direction: column;
		gap: rem(16);
		align-items: flex-start;
	}

	&__section-title {
		color: #fe324b;
		font-size: rem(12);
		line-height: rem(12);
		font-weight: 700;
	}

	&__links {
		display: flex;
		flex-direction: column;
		gap: rem(16);
		align-items: flex-start;
	}

	&__link {
		color: #fff;
		font-size: rem(12);
		line-height: rem(12);
		font-weight: 400;
		text-decoration: none;
		display: block;

		&:hover {
			color: rgba(#fff, 0.5);
		}
	}

	&__toast {
		position: fixed;
		bottom: 50%;
		left: 50%;
		transform: translate(-50%, 50%);
		padding: rem(10) rem(20);
		background: rgba(0, 0, 0, 0.7);
		color: #fff;
		border-radius: rem(4);
		z-index: 9999;
		font-size: rem(14);
		max-width: rem(200);
		text-align: center;
	}

	// 移动端样式
	&--mobile {
		padding: rem(40) rem(16);

		.app-footer__container {
			flex-direction: column;
			gap: rem(24);
		}

		.app-footer__logo-container {
			margin-bottom: 0;
		}

		.app-footer__logo-section {
			height: auto;
		}

		.app-footer__desc {
			width: 100%;
			margin-bottom: 0;
		}

		.app-footer__divider {
			height: 1px;
			width: 100%;
		}

		.app-footer__right-section {
			gap: rem(60);
			width: 100%;
			justify-content: space-between;
		}

		.app-footer__copyright {
			width: 100%;
		}
	}
}
</style> 